import React from 'react';

type InfoSectionProps = {
    icon: React.ReactNode;
    title: string;
    children: React.ReactNode;
    lastUpdated?: string;
};

const InfoSection: React.FC<InfoSectionProps> = ({ icon, title, children, lastUpdated }) => (
    <article className="info-section">
        <header className="info-section__header">
            <span className="info-section__icon">{icon}</span>
            <h2 className="info-section__title">{title}</h2>
        </header>
        <div className="info-section__body">{children}</div>
        {lastUpdated && <footer className="info-section__footer">Last updated: {lastUpdated}</footer>}
    </article>
);

export default InfoSection;
